import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { NavLink } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';

import { useStyles } from './FullPageImgStyles.js'

function FullPageImg({ company, actionLinks }) {

    const classes = useStyles();

    return (
        <>
            <Box className={classes.homepageBackground}>
                <Box className={classes.homepageOverlay}>
                    <Container maxWidth="xl">
                        <Box className={classes.siteInfoWrapper}>
                            <img src={company.logo_alt} width="50" className={classes.siteLogo} title={company.name} alt={company.name} />
                            <Typography variant="h1" className={classes.siteTitle}>
                                {company.name}
                            </Typography>
                            <Typography variant="h2" className={classes.siteSubTitle}>
                                {company.slogan}
                            </Typography>
                            {actionLinks[0].external ? (
                                // Esterno (WhatsApp)
                                <Button
                                    variant="outlined"
                                    className={classes.actionButton}
                                    href={actionLinks[0].link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={actionLinks[0].title}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16" style={{marginRight: '8px'}}>
                                        <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                    </svg>
                                    {actionLinks[0].title}
                                </Button>
                            ) : (
                                // Interno
                                <Button
                                    variant="outlined"
                                    className={classes.actionButton}
                                    component={NavLink}
                                    to={actionLinks[0].link}
                                    title={actionLinks[0].title}
                                >
                                    {actionLinks[0].title}
                                </Button>
                            )}
                        </Box>
                        <Grid container spacing={2} className={classes.homeActionWrapper}>

                            {[actionLinks[1], actionLinks[2]].map((action, index) => (
                                <Grid item xs={12} md={6} key={index}>

                                    {action.external ? (
                                        // Link esterno (WhatsApp)
                                        <Link
                                            color="inherit"
                                            className={classes.homeActionLink}
                                            href={action.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title={action.title}
                                        >
                                            <Paper elevation={2} className={classes.homeActionButton}>
                                                {action.title}
                                            </Paper>
                                        </Link>
                                    ) : (
                                        // Link interno
                                        <Link
                                            color="inherit"
                                            className={classes.homeActionLink}
                                            component={NavLink}
                                            to={action.link}
                                            title={action.title}
                                        >
                                            <Paper elevation={2} className={classes.homeActionButton}>
                                                {action.title}
                                            </Paper>
                                        </Link>
                                    )}

                                </Grid>
                            ))}

                        </Grid>
                    </Container>
                </Box>
            </Box>
        </>
    );
}

export default FullPageImg;

